// extracted by mini-css-extract-plugin
export default {"upload":"UploadText_upload__DSDDq","file":"UploadText_file__fFrR9","upload-hint":"UploadText_upload-hint__gbMl9"};